import { render, staticRenderFns } from "./policy-content.vue?vue&type=template&id=21f03629&scoped=true&"
import script from "./policy-content.vue?vue&type=script&lang=js&"
export * from "./policy-content.vue?vue&type=script&lang=js&"
import style0 from "./policy-content.vue?vue&type=style&index=0&id=21f03629&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f03629",
  null
  
)

export default component.exports